import MoqInformation from '../../../../components/moq-information/moq-information.desktop';
import moqInformation from './moq-information';

const configuredMoqInformation = moqInformation(MoqInformation);
export default configuredMoqInformation;
